import React from "react";
import { graphql, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Layout from "../components/layout"
import Seo from "../components/seo"

const title = "MPUF XRCC バーチャル時計台"
const scope = "デジタルツイン空間制作"
const str1 = "歴史的建造物である「時計台」を、一部バーチャル・リノベーションを行い国際会議場としてVR空間化した。"
const str2 = "1:200の図面と写真のみからフルスクラッチで細部を起こし、シンボルとしてのイメージ再現を行った。中央の大階段は、時計をシャンデリアに転用するなど、オリジナルのディテールのみを再編集して意匠に用いた新規空間である。"

const settings = {
  arrows: false,
  fade: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  pauseOnHover: false,
}

export default ({ data, location }) => (
      <Layout>
        <Seo
          pagetitle={title}
          pagedesc={str1}
          pagepath={location.pathname}
          pageimg={data.tokeidai01.childImageSharp.original.src}
          pageimgw={data.tokeidai01.childImageSharp.original.width}
          pageimgh={data.tokeidai01.childImageSharp.original.height}
        />
        <div className="nav">
          <Link to = {`/works/`}>
            <svg className="switchButton" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.41 52.83">
            <g id="_レイヤー_2" data-name="レイヤー_2">
              <g id="UI">
                <path d="M1.4,2.2l47.3,24.2L1.4,50.7l.4.9,47.9-24.6,47.9,24.6.5-.9-47.3-24.3L98,2.1l-.5-.9-47.8,24.6L1.8,1.2l-.4.9Z"/>
              </g>
            </g>
            </svg>
          </Link>
        </div>
        <div id="pageBody" className="wrapper">
          <Slider {...settings}>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai01.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai02.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai03.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai04.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai05.jpg" alt="" />
            </div>
            <div className="full">
              <StaticImage className="cover" src="../images/tokeidai06.jpg" alt="" />
            </div>
          </Slider>
          <div className="title">
            <h4>{title}</h4>
            <p><span>{scope}</span></p>
            <br />
            <p>{str1}</p>
            <p>{str2}</p>
          </div>
        </div>
      </Layout>
)

export const query = graphql`
query {
  tokeidai01: file(relativePath: {eq: "tokeidai01.jpg"}) {
    childImageSharp {
      original {
        height
        src
        width
      }
    }
  }
}
`
